<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Notulen Ujian: ' + title" @back="back">
            <common-training-header :withUser="true" :user_hash="user_hash" />
        </a-page-header>

        <a-card type="inner" size="small" v-if="identity !== 'report'">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
                    <a-row type="flex">
                        <a-col><strong>INFORMASI</strong></a-col>
                        <a-col></a-col>
                    </a-row>

                    <a-form-model-item label="Grup">
                        <a-input v-model="formData.group" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-form-model-item label="Lokasi Ujian">
                        <a-input v-model="formData.presentation_location" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-form-model-item label="Waktu Pelaksanaan">
                        <a-date-picker
                            show-time
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                            @change="onStartDateChange"
                            :format="'YYYY-MM-DD HH:mm:ss'"
                            v-model="formData.exam_time"
                            type="date"
                            :disabled="identity !== 'report' ? false : true"
                        />
                    </a-form-model-item>

                    <a-form-model-item label="Penguji">
                        <a-textarea v-model="formData.tester" :rows="4" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-row type="flex">
                        <a-col><strong>PELAKSANAAN</strong></a-col>
                        <a-col></a-col>
                    </a-row>

                    <a-form-model-item label="Peserta">
                        <a-input v-model="formData.attendant" :disabled="identity !== 'report' ? false : true" :default-value="attendant"/>
                    </a-form-model-item>

                    <a-form-model-item :label="'Judul ' + title">
                        <a-textarea v-model="formData.title_project" :rows="4" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-form-model-item label="Waktu Presentasi">
                        <a-date-picker
                            show-time
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                            @change="onPresentationDateChange"
                            :format="'YYYY-MM-DD HH:mm:ss'"
                            v-model="formData.presentation_time"
                            type="date"
                            :disabled="identity !== 'report' ? false : true"
                        />
                    </a-form-model-item>

                    <a-form-model-item label="Waktu Diskusi">
                        <a-date-picker
                            show-time
                            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                            @change="onDiscussDateChange"
                            :format="'YYYY-MM-DD HH:mm:ss'"
                            v-model="formData.discussion_time"
                            type="date"
                            :disabled="identity !== 'report' ? false : true"
                        />
                    </a-form-model-item>

                    <a-form-model-item label="Keterangan">
                        <a-textarea v-model="formData.description" :rows="4" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-form-model-item label="Uraian">
                        <a-textarea v-model="formData.note" :rows="4" :disabled="identity !== 'report' ? false : true"/>
                    </a-form-model-item>

                    <a-form-model-item>
                        <a-row type="flex" justify="end" align="top">
                            <a-col>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="handleSubmit"
                                    v-if="identity !== 'report'">Submit</a-button>
                            </a-col>
                        </a-row>
                    </a-form-model-item>

                </a-form-model>
            </a-skeleton>
        </a-card>
        <a-card type="inner" size="small" v-else>
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="data"
                :loading="preload"
                :pagination="false" bordered>

                <div slot="name" slot-scope="record">
                    <strong>{{ record.title }}</strong>
                </div>

                <div slot="dot" slot-scope="record">
                    :
                </div>

                <div slot="description" slot-scope="record">
                    {{ record.description }}
                </div>
            </a-table>

            <a-table
                class="pcp-table"
                :columns="columnsSecond"
                :dataSource="data_second"
                :loading="preload"
                :pagination="false" bordered
                style="margin-top: 12px">

                <div slot="name" slot-scope="record">
                    <strong>{{ record.title }}</strong>
                </div>

                <div slot="dot" slot-scope="record">
                    :
                </div>

                <div slot="description" slot-scope="record">
                    {{ record.description }}
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'name',
            title: 'INFORMASI',
            colSpan: 3,
            width: '200px',
            scopedSlots: {customRender: 'name'},
        }, {
            key: 'dot',
            title: '',
            colSpan: 0,
            width: '5px',
            scopedSlots: {customRender: 'dot'},
        }, {
            key: 'description',
            title: '',
            colSpan: 0,
            scopedSlots: {customRender: 'description'}
        },
    ]

    const columnsSecond = [
        {
            key: 'name',
            title: 'PELAKSANAAN',
            colSpan: 3,
            width: '200px',
            scopedSlots: {customRender: 'name'},
        }, {
            key: 'dot',
            title: '',
            colSpan: 0,
            width: '5px',
            scopedSlots: {customRender: 'dot'},
        }, {
            key: 'description',
            title: '',
            colSpan: 0,
            scopedSlots: {customRender: 'description'}
        },
    ]
    export default {
        props: {
            user_hash: {
                type: String,
                default: ''
            },
            outline: {
                type: String,
                required: true
            },
            identity: {
                type: String,
                required: false,
                default: ''
            },
            previous: {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                columns,
                columnsSecond,
                labelCol: { span: 5 },
                wrapperCol: { span: 10 },
                label: 2,
                input: 22,
                form: this.$form.createForm(this),
                preload: false,
                processing: false,
                formData: {},
                userInfo: {},
                data: [
                    {
                        key: '1',
                        title: 'Group',
                        description: null
                    },
                    {
                        key: '2',
                        title: 'Lokasi Ujian',
                        description: null
                    },
                    {
                        key: '3',
                        title: 'Waktu Pelaksanaan',
                        description: null
                    },
                    {
                        key: '4',
                        title: 'Penguji',
                        description: null
                    }
                ],
                data_second: [
                    {
                        key: '1',
                        title: 'Nama Peserta',
                        description: null
                    },
                    {
                        key: '2',
                        title: 'Judul Project',
                        description: null
                    },
                    {
                        key: '3',
                        title: 'Waktu Presentasi',
                        description: null
                    },
                    {
                        key: '4',
                        title: 'Keterangan',
                        description: null
                    },
                    {
                        key: '5',
                        title: 'Uraian',
                        description: null
                    }
                ],
            }
        },
        created() {
            if (this.user_hash !== null) {
                this.getInfo()
            }

            if (this.editing) {
                this.preload = true
                this.getItem()
            }
        },
        computed: {
            activeModule() {
                return this.$laravel.active_module
            },
            title(){
                switch(this.outline) {
                    case "proposal":
                        return "Proposal"
                    case "project_evaluation":
                        return "Evaluasi Project"
                    case "evaluation":
                        return "Evaluasi Kinerja"
                    default:
                        return "Makalah"
                }
            },
            editing() {
                return this.user_hash !== "";
            },
            attendant(){
                return this.userInfo.name
            }
        },
        methods: {
            getItem() {
                let params = {
                    user_hash: this.user_hash
                }

                if(this.outline != 'paper' && this.outline != 'evaluation'){
                    params = Object.assign(params, { outline: this.outline })
                }

                this.$http
                    .get(this.routeUri("api.activity-notulens") + '?' + this.$qs.stringify(params))
                    .then(response => {
                        if(response.data.notulens.length > 0){
                            this.formData = response.data.notulens[0]
                        }
                    })
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.preload = false))
            },
            getInfo(){
                if (this.user_hash !== null) {
                    this.$http
                        .post(this.routeUri('api.general.user.info', { user_hash: this.user_hash}))
                        .then(response => (this.userInfo = response.data))
                        .catch(error => this.handleXhrError(error))
                        .finally(() => (this.loading = false))
                }
            },
            handleSubmit(e) {
                e.preventDefault(e);

                this.processing = true;

                let promise;

                let params = {
                    user_hash: this.user_hash
                }

                this.formData.attendant = this.userInfo.name

                if(this.outline != 'paper' && this.outline != 'evaluation')
                    params = Object.assign(params, { outline: this.outline })

                promise = this.$http.post(
                    this.routeUri("api.activity-notulens.store_update") + '?' + this.$qs.stringify(params),
                    this.formData
                );

                promise
                    .then(response =>
                        this.handleSuccessResponse(response.data)
                    )
                    .catch(error =>
                        this.handleResponseError(error.response.data)
                    )
                    .finally(() => (this.processing = false));
            },
            handleSuccessResponse(data) {
                var successMessage = "Data berhasil diproses!";

                if (typeof data.successMessage != "undefined") {
                    successMessage = data.successMessage;
                }

                this.$notification.success({
                    message: "Sukses!",
                    description: successMessage
                });

                let params = {
                    user_hash: this.user_hash,
                    identity: 'input',
                    previous: this.previous
                }

                if(this.outline != 'paper' && this.outline != 'evaluation'){
                    params = Object.assign(params, { outline: this.outline })

                    setTimeout(() => window.location.replace(this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.' + this.outline + '.form') + '?' + this.$qs.stringify(params)), 1000)
                }else{
                    setTimeout(() => window.location.replace(this.routeUri('admin.' + this.activeModule.module.identifier + '.notulen.form') + '?' + this.$qs.stringify(params)), 1000)
                }


            },
            handleResponseError(data) {
                if (data.hasOwnProperty("errors")) {
                    for (let key in data.errors) {
                        this.$notification.error({
                            message: "Gagal proses " + key,
                            description: Object.values(data.errors[key])
                        });
                    }
                } else {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data tidak dapat diproses."
                    });
                }
            },
            onStartDateChange(date, dateString) {
                this.formData.exam_time = dateString
            },
            onPresentationDateChange(date, dateString) {
                this.formData.presentation_time = dateString
            },
            onDiscussDateChange(date, dateString) {
                this.formData.discussion_time = dateString
            },
            back() {
                window.location.href = this.routeUri(this.previous)
            },
        },
        watch: {
            formData: function(value) {
                this.data[0].description = value.group
                this.data[1].description = value.presentation_location
                this.data[2].description = value.exam_time
                this.data[3].description = value.evaluator.name

                this.data_second[0].description = value.attendant
                this.data_second[1].description = value.title_project
                this.data_second[2].description = value.presentation_time
                this.data_second[3].description = value.description
                this.data_second[4].description = value.note
            }
        }
    }
</script>
